/**
 * Header Animation
 */
import { gsap } from 'gsap';

export function page_lv2_header_animation() {
	const header = document.querySelector('.p-page-header-lv2');
	if (!header) return;

	const titleJp = header.querySelector('.title_jp > span');
	const titleEn = header.querySelector('.title_en-mask > span');
	const image = header.querySelector('.p-page-header-lv2__thumb img');

	if (!titleJp || !image) return;

	gsap.set(titleJp, {
		yPercent: 110,
  	autoAlpha: 1
	});

	if (titleEn) {
		gsap.set(titleEn, {
			yPercent: 110,
  		autoAlpha: 1
		});
	}

	gsap.set(image, {
		// opacity: 0,
		scale: 1.15
	});

	const tl = gsap.timeline({
		defaults: {
			ease: 'power3.out'
		}
	});

	tl.to(titleJp, {
		yPercent: 0,
		duration: 0.8
	});

	if (titleEn) {
		tl
			.fromTo(
				titleEn,
				{
					yPercent: 110
				},
				{
					yPercent: 0,
					duration: 0.7
				},
				'-=0.45'
			)
			.to(
				image,
				{
					// opacity: 1,
					scale: 1,
					duration: 1.4,
					ease: 'power2.out'
				},
				'<'
			);
	} else {
		tl.to(
			image,
			{
				opacity: 1,
				scale: 1,
				duration: 1.4,
				ease: 'power2.out'
			},
			'-=0.45'
		);
	}
}